export default "__VITE_ASSET__210334d4__"